export default __webpack_public_path__ + "static/media/itbmun-update.ffc5f1e0.png";